import { Component, OnInit, forwardRef } from '@angular/core';
import { LookupService } from '../../../../../../shared/core/services/lookup.service';
import { NotImplementedViewModel } from '../../../../../../shared/ui-ndms/view-models/not-implemented.view-model';
import { FormGroup } from '@angular/forms';
import { FormObjects } from '../../../../../../shared/core/utilities/formObjects';
import { HasSearchModalComponent } from '../../../../../../shared/core/interfaces/hasSearchModalComponent';
import { ViewModelService } from '../../../../../../shared/core/services/view-model.service';
import { TeamsHomeService } from '../../../../teams/teams-home/shared/services/teams-home.service';
import { TeamsService } from '../../../core-rms/teams.service';

@Component({
  selector: 'search-team-modal',
  templateUrl: './search-team-modal.component.html',
  styleUrls: ['./search-team-modal.component.scss'],
  providers: [{ provide: HasSearchModalComponent, useExisting: forwardRef(() => SearchTeamModalComponent) }],
})
export class SearchTeamModalComponent extends HasSearchModalComponent implements OnInit {

  constructor(public teamsService: TeamsService, lookupService: LookupService, viewModelService: ViewModelService) {
    super(lookupService, viewModelService, NotImplementedViewModel, false);

    this.form = new FormGroup({
      teamName: FormObjects.String(),
      classification: FormObjects.Lookup(),
      teamType: FormObjects.Lookup(),
      region: FormObjects.Lookup(),
      pageNumber: FormObjects.Data(0)
    });
    
  }

  ngOnInit() {
  }

}
